<template>
  <div>

    <breadcrumb></breadcrumb>
    
    <div class="row">
      <div class="col">
          <h5>Solicitações do Web</h5>
          <table class="table table-sm">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Nome</th>
                <th scope="col">Usuário</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in data" :key="item._id">
                  <td scope="row">{{item.nome}}</td>
                  <td scope="row">{{item.usuario.name}}</td>
                  <td>
                    <a href="javascript;" @click.prevent="remove(item._id)" title="Remover">remover</a>
                  </td>
                </tr>
              </tbody>
          </table>

          <h5>Solicitações do APP</h5>
          <table class="table table-sm">
            <thead class="thead-dark">
              <tr>
                <th scope="col">Data</th>
                <th scope="col">Nome</th>
                <th scope="col">Usuário</th>
                <th scope="col"></th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="item in fromapp" :key="item._id">
                  <td scope="row">{{item.data}}</td>
                  <td scope="row">{{item.nome}}</td>
                  <td scope="row">{{item.usuario.nome}}</td>
                  <td>
                    <a href="javascript;" @click.prevent="remove(item._id)" title="Remover">remover</a>
                  </td>
                </tr>
              </tbody>
          </table>

      </div>
    </div>
  </div>
</template>

<script>
import ls from 'local-storage'

export default {
  name: 'Solicitacoes',
  data() {
    return {
      fromapp: [],
      data: [],
      api: '',
      token: ''
    }
  },
  methods: {
    remove(id) {
      this.$http.delete(`/v1/alimento/solicitacao/${id}`).then(() => {
        window.location.reload();
      })
    }
  },
  beforeMount() {
    this.api = process.env.API_ENV
    this.token = ls('token')

    this.$http.get('/v1/alimento/solicitacoes').then((response) => {
      this.data = response.data.data
      this.fromapp = response.data.fromapp
    });
  }
}
</script>




// WEBPACK FOOTER //
// src/components/solicitacoes/SolicitacaoHome.vue